import DigitalReadinessQuiz from './../components/sections/Tools/Quiz/DigitalReadinessQuiz/DigitalReadinessQuiz';

const DigitalReadinessPage = () => {
  return (
    <>
      <DigitalReadinessQuiz />
    </>
  );
};

export default DigitalReadinessPage;